export default __webpack_public_path__ + "static/media/En-transporte.0f875ad1.svg";